export var INITIAL_DOWN_DATA = [
    { id: "1", numericalTitle: "0", title: "Ventas netas" },
    { id: "2", numericalTitle: "0", title: "Cotizaciones" },
    { id: "3", numericalTitle: "0", title: "Pólizas canceladas" },
];
export var buildChartSeries = function (tl) { return [
    {
        color: "#3A56A1",
        data: [],
        name: "Emitidas",
    },
    {
        color: "#A8B5D6",
        data: [],
        name: "Cotizadas",
    },
]; };
export var INITIAL_CATEGORIES = [];
export var DATE_RANGE_CHIPS = [
    { active: true, id: "1", name: "Mes actual", code: "currentMonth" },
    { active: false, id: "2", name: "Mes anterior", code: "prevMonth" },
    { active: false, id: "3", name: "Trimestre actual", code: "currentQuarter" },
    { active: false, id: "4", name: "Trimestre anterior", code: "prevQuarter" },
    { active: false, id: "5", name: "Semestre actual", code: "currentSemester" },
];
export var REPORT_ACTION_OPTIONS = [{ id: "1", name: "Previsualizar" }];
// * Ids de reportes (ReportApiItem.id) que no deben mostrarse en el panel,
export var EXCLUDED_REPORT_IDS = [
    "8521e560-4a14-436a-b2e3-adfe877c4e54",
    "5e0b7578-56db-482a-a840-03acb2a38bb1",
    "8985395f-3a0b-46ce-ab42-ac94bfcf6920",
];
export var reportSortPriority = function (name) {
    if (name.includes("Generales"))
        return 0;
    if (name.includes("Canceladas"))
        return 1;
    return 2;
};
/**
 * Categoría del reporte usada por el panel de ReportsPageV2AFY para agrupar y
 * mostrar los chips (Ventas / Pólizas / Clientes / Cobros / Cancelaciones).
 * El backend no envía categoría, así que se deriva por palabras clave del
 * nombre. Siempre devuelve una categoría no vacía (nunca "sin grupo") para que
 * el componente muestre los chips.
 */
export var deriveReportCategory = function (name) {
    var n = (name || "").toLowerCase();
    if (/(cancel|anulad|baja)/.test(n))
        return "Cancelaciones";
    if (/(cliente|asegurad)/.test(n))
        return "Clientes";
    if (/(cobro|prima|morosidad|pago|saldo|cuota|recaud)/.test(n))
        return "Cobros";
    if (/(p[oó]liza|renovaci|vigencia|antig[uü]edad|cartera|certificad)/.test(n))
        return "Pólizas";
    return "Ventas";
};
